import React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { Fab, Card, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import api from "../../../components/services/api";
import SearchData from "../components/SearchData";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { useSelector } from "react-redux";
import moment from "moment";
import {
  GridToolbarContainer,
  GridToolbarExport,
  gridClasses,
} from "@mui/x-data-grid";
import Swal from "sweetalert2";
import SearchIcon from '@mui/icons-material/Search';

export default function ContainerManagement() {
  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [idDialog, setIdDialog] = useState("");
  const [bay, setBay] = useState('')
  const [row, setRow] = useState('')
  const [tier, setTier] = useState('')
  const [idEdit, setIdEdit] = useState("");
  const EmpId = localStorage.getItem("EmpId");
  const [stDate, setstDate] = useState(null);
  const [enDate, setenDate] = useState(null);
  const [toAction, setToAction] = useState('');
  const [locationId, setLocationId] = useState('');
  const MenuActive = useSelector((state) => state.MenuActive.List);
  const [searchText, setSearchText] = useState('')
  const [locationData, setLocationData] = useState([])
  // กดค้นหาซ้ำระหว่างที่ยังโหลดไม่เสร็จ = query ซ้อนกันบน server (2026-10-31 search กองจน prod ค้าง) -> ล็อกปุ่มไว้จนกว่าจะได้ผล
  const [loading, setLoading] = useState(false)

  const [search, setSearch] = useState({
    startDate: stDate,
    endDate: enDate,
    Keyword: '',
    ToAction: '',
    locationId: ''
  })
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };


  /* table data */
  const columns = [
    // {
    //   field: "Status",
    //   headerName: "Status",
    //   width: 150,
    //   renderCell: ({ value }) =>

    //       <Chip
    //         label={value.toUpperCase()} style={{ color: "white", backgroundColor: value === 'Stock' ? "#28A745" : value === 'Out Stock' ? '#3C5959': '#FFA101' }}
    //       />
    // },
    { field: "SaleOrderNo", headerName: "Sale Order No.", width: 200 },
    { field: "Quantity", headerName: "Quantity", width: 80 },
    { field: "ShipperRefNo", headerName: "Shipper Ref No.", width: 180 },
    { field: "BookingNo", headerName: "Booking No.", width: 200 },
    { field: "GateOut", headerName: "Gate Out", width: 200 },
    { field: "VoyIn", headerName: "VOY IN ", width: 150 },
    { field: "GateIn", headerName: "Gate IN", width: 150 },
    { field: "VoyOut", headerName: "VOY OUT", width: 150 },
    {
      field: "Action",
      width: 130,
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <Link
              to={{
                pathname: `/Planner/ViewContainerManagement/${params.id}`,
              }}
            >
              <Button
                variant="contained"
                style={{ textTransform: "none", backgroundColor: "#007BFF" }}
              >
                View
              </Button>
            </Link>

          </>
        );
      },
    },
  ];

  //Submit Edit

  const submitEdit = async () => {
    if (idDialog !== "") {
      const params = {
        StockMovementID: idDialog.StockMovementID,
        ToBay: bay,
        ToRow: row,
        ToTier: tier
      }
      try {
        const res = await api.post("api/containermovement/EditContainermovement", params);
        if (res.meta.status) {
          setOpen(false);
          Swal.fire({
            title: `${res.meta.message}`,
            icon: 'success',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK',
            allowOutsideClick: false
          }).then((result) => {
            if (result.isConfirmed) {
              getData();

            }
          })
        }
      } catch (e) {
        console.log(e);
      }
    } else {
      alert("กรุณากรอกรหัสตู้");
    }
  };

  //fetch Data
  const getData = async () => {
    setLoading(true);
    try {
      const data = await api.get(`api/containermanagement/list?${search.startDate ? `startDate=${search.startDate}` : ''}${search.endDate ? `&endDate=${search.endDate}` : ''}&keyword=${search.Keyword}&ToAction=${search.ToAction}&locationId=${search.locationId}`);
      setData(data.data);
      setDataFilter(data.data);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  const getLocation = async () => {
    try {
      const res = await api.get("api/location/list");
      const data = await res.data
      if (res.meta.status === true) {
        setLocationData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  // const getDate = async () => {
  //   const params = {
  //     groupId: "G002",
  //     stDate: moment(stDate).format("YYYY-MM-DD"),
  //     enDate: moment(enDate).format("YYYY-MM-DD"),
  //   };
  //   try {
  //     await api
  //       .post("api/planner/container/list/search", params)
  //       .then((res) => {
  //         console.log(res);
  //         setData(res.data);
  //         setDataFilter(res.data);
  //       });
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };
  //api call
  useEffect(() => {
    // GET request using axios inside useEffect React hook
    getData();
    getLocation()
    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [search]);

  //Floating Button
  const floating_action_style = {
    margin: 0,
    top: "auto",
    right: 20,
    bottom: 10,
    left: "auto",
    position: "fixed",
  };
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          จัดการคอนเทนเนอร์
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Container Management
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Planner</Typography>
            <Typography>
              <span>&nbsp;</span> / ContainerManagement
            </Typography>
          </Grid>
        </Grid>
        <Box
          sx={{
            marginTop: "10px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "end",
            alignItems: 'center'
          }}
        >
          {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              inputFormat="yyyy/MM/dd"
              value={stDate}
              onChange={(e) => {
                setstDate(moment(e).format("YYYY-MM-DD"));
                // getDate();
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  label="ระยะเวลาบริการ-เริ่มต้น"
                  style={{

                    width: "15%",
                    marginRight: '10px'
                  }}
                />
              )}
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              inputFormat="yyyy/MM/dd"
              value={enDate}
              onChange={(e) => {
                setenDate(moment(e).format("YYYY-MM-DD"));
                // getDate();
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="ระยะเวลาบริการ-สิ้นสุด"
                  size="small"
                  style={{
                    marginRight: '10px',
                    width: "15%",
                  }}
                />
              )}
            />
          </LocalizationProvider> */}
          <FormControl size="small" sx={{
            width: "15%", marginRight: '10px',
          }}>
            <InputLabel>Location Gate In</InputLabel>
            <Select
              label="Location Gate In"
              value={locationId}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {

                setLocationId(e.target.value)
              }}
              MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}

            // disabled={values.liners !== ""}
            >

              <MenuItem
                value={'all'}

              >
                ทั้งหมด
              </MenuItem>
              {locationData?.map((x) => {
                return (
                  <MenuItem
                    value={x?.LocationId}

                  >
                    {x?.LocationName}
                  </MenuItem>
                )
              })}

            </Select>
          </FormControl>

          <TextField value={searchText} onChange={e => setSearchText(e.target.value)} size="small" id="outlined-basic" label="Keyword" variant="outlined" />
          <Button
            style={{
              backgroundColor: "#0d6efd",
              color: "#fafafa",
              marginLeft: "10px"
            }}
            disabled={loading}
            onClick={() => setSearch({
              startDate: stDate ? moment(stDate).format('yyyy-MM-DD') : '',
              endDate: enDate ? moment(enDate).format('yyyy-MM-DD') : '',
              Keyword: searchText,
              ToAction: toAction,
              locationId: locationId === 'all' ? '' : locationId

            })}
          >
            <SearchIcon />
          </Button>
          {/* <Grid item sx={{ display: "flex", alignItems: "center" }}>
            <SearchData name={data} onsetData={setDataFilter} />
          </Grid> */}
        </Box>

        <Box
          sx={{
            height: 590,
            width: "100%",
            marginTop: "10px",
            "& .Active": {
              color: "#28A745",
            },
            "& .Inactive": {
              color: "#F53C56",
            },
          }}
        >
          <DataGrid
            getRowId={(r) => r?.SaleOrderId}
            rows={dataFilter}
            loading={loading}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            hideFooterSelectedRowCount
            disableColumnFilter
            disableColumnMenu
            getCellClassName={(params) => {
              if (params.field === "Status") {
                return params.value == true ? "Active" : "Inactive";
              }
            }}
          />
        </Box>
      </Card>
      {MenuActive.find((x) => x.ActionNo === "A027") && (
        <Link to="/Planner/AddContainerList">
          <Fab color="primary" style={floating_action_style} aria-label="add">
            <AddIcon />
          </Fab>
        </Link>
      )}

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Edit </DialogTitle>
        <DialogContent>
          <DialogContentText>ID = {idDialog.ContainerNo}</DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="Bay"
            label="Bay"
            value={bay}
            fullWidth
            variant="standard"
            onChange={(e) => setBay(e.target.value)}
          />
          <TextField
            autoFocus
            margin="dense"
            id="Row"
            label="Row"
            value={row}
            fullWidth
            variant="standard"
            onChange={(e) => setRow(e.target.value)}
          />
          <TextField
            autoFocus
            margin="dense"
            id="Tier"
            label="Tier"
            value={tier}
            fullWidth
            variant="standard"
            onChange={(e) => setTier(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>ยกเลิก</Button>
          <Button
            onClick={() => {

              submitEdit();
            }}
          >
            ยืนยัน
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
